import { Component, OnInit, Input, Output, EventEmitter, OnChanges, Renderer2 } from '@angular/core';
import { Location } from '@angular/common';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { NoteService } from '@app/_components/task/note';
import { AlertService } from '@app/_services';
import { ApiResponse } from '@app/_models';
import { Note } from '@app/_components/task/note';
import { SelectItem, LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { take } from 'rxjs/operators';
import { NoteComponent } from './../note/note.component';



@Component({
    selector: 'app-note-list',
    templateUrl: './note-list.component.html',
    styleUrls: ['./note-list.component.css'],
    standalone: false
})
export class NoteListComponent implements OnInit, OnChanges
{
  Renderer2: any;

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private noteService: NoteService,
		private alertService: AlertService,
		private messageService: MessageService,
		private location: Location,
		private dialog: MatDialog,
    private renderer: Renderer2,
		private formBuilder: UntypedFormBuilder) { }

	// inputs
	@Input() noteSource: number;
	@Input() noteSourceId: number;
	@Input() isPublicAndPublish: boolean;


	// structure
	subscription: Subscription;
	routerLocation = this.location;


	// data
	noteApiResponse: ApiResponse;


	// list
	datasource: Note[];

	notes: Note[] = [];
	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;

	multiSortMeta = [];


	// forms
	noteAddForm: UntypedFormGroup;
	noteEditForm: UntypedFormGroup;
	formLoading = false;
	formAction: String;
	formLabels = [];
	formReadOnly = false;
	note:any;


	noteTypes = [
		{ value: 1, name: 'General', color: '#DCDCDC' },
		{ value: 2, name: 'Action Item', color: '#ffcccc' },
		{ value: 3, name: 'Status Report', color: '#FFFF99' },
		{ value: 4, name: 'Meeting Notes', color: '#95a264' },
		{ value: 5, name: 'Status Update', color: '#d9d96e' },
	];

	visibilities = [
		{ value: 1, name: 'Company' },
		{ value: 2, name: 'Team' },
		{ value: 3, name: 'Personal' },
		{ value: 1, name: '' },
		{ value: 4, name: 'Customer/Owner' }
	];

	statuses = [
		{ value: 0, name: 'Open' },
		{ value: 1, name: 'Complete' },
    { value: 2, name: 'Proposed' },
    { value: 3, name: 'On Hold' },
    { value: 4, name: 'Canceled' },
    { value: 5, name: 'In Progress' }
  ];

	columns: any[] = [
    { field: 'createDate', header: 'Created', width: '10%' },
		{ field: 'title', header: 'Title', width: '20%' },
		{ field: 'description', header: 'Description', width: '30%' },
		{ field: 'createdBy', header: 'createdBy', width: '15%' },
		{ field: 'status', header: 'Status', width: '10%' },
		{ field: 'noteType', header: 'Type', width: '10%' },
		{ field: 'lastUpdate', header: 'Edited', width: '10%' },
	];

	filters: any[] = [

		{ label: 'Created', value: 'createDate' },
		{ label: 'Edited', value: 'lastUpdate' },
		{ label: 'Status', value: 'status' },
		{ label: 'Type', value: 'noteType' },
		{ label: 'Visibility', value: 'visibility' },

	];


	// validation
	validationMessages = {
		'name': [
			{ type: 'required', message: 'Required' }
		],
		'noteId': [],
		'createDate': [],
		'lastUpdate': [],
		'title': [],
		'description': [{ type: 'required', message: 'Required' }],
		'status': [],
		'noteType': [],
		'visibility': []
	};


	ngOnInit()
	{
		this.buildAddForm();
		this.buildEditForm();

		try
		{
			// adding
			if (this.noteSourceId == null)
			{
				console.log('action: add.  ns' + this.noteSource + ' ' + this.noteSourceId);
			}

			// editing
			if (this.noteSourceId != null)
			{
				console.log('action: edit');
				// this.noteId = this.noteEditForm.controls.noteId.value;
			}


			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error)
		{
			console.log('Error: ' + error);
		}
	}



	formAdd()
	{
		console.log('trying to add: ');
		try
		{
			// stop here if form is invalid
			if (this.noteAddForm.invalid)
			{
				return;
			}

			this.formLoading = true;

			// use the .pipe(take(1)) to prevent double firing...
			this.noteService.add(this.noteAddForm.value).pipe(take(1))
				.subscribe(
					res =>
					{
						console.log('Note-Add SUCCESS: ' + JSON.stringify(res));
						this.alertService.success(res, true);
						this.notes.unshift(res.data.note);
						this.buildAddForm();
					},
					err =>
					{
						console.log('Note-Add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error)
		{
			this.alertService.error(error);
		}
	}

	formUpdate()
	{
		try
		{
			// stop here if form is invalid
			console.log('Form Submitted: ' + JSON.stringify(this.noteEditForm.value));
			if (this.noteEditForm.invalid)
			{
				console.log('Form Invalid: ' + JSON.stringify(this.noteEditForm.getError));
				return;
			}

			this.formLoading = true;
			this.noteService.update(this.noteEditForm.value)
				.subscribe(
					res =>
					{
						console.log('Note-Update SUCCESS: ' + JSON.stringify(res));

						// update the list
						this.notes.map((note, i) =>
						{
							if (note.noteId === res.data.note.noteId)
							{
								this.notes[i] = res.data.note;
							}
						});
						this.alertService.success(res, true);
					},
					err =>
					{
						console.log('Note-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error)
		{
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	loadLazy(event: LazyLoadEvent)
	{

		this.lazyLoadEvent = event;
		const pageNumber = Math.round(event.first / event.rows);
		console.log(
			' event.first:' + event.first
			+ '  |  event.rows:' + event.rows
			+ '  |  event.sortField:' + event.sortField
			+ '  |  event.sortOrder:' + event.sortOrder
			+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
			+ '  |  event.globalFilter:' + event.globalFilter
			+ '  |  event.filters:' + JSON.stringify(event.filters)
		);
		if ( 1 === this.noteSource &&  !event.filters['status']){
			event.filters['status'] = {};
			event.filters['status'].value = [1 , 2 , 3 , 0, 5];
			event.filters['status'].matchMode = 'in';
		}


		// if empty (ie when parent is in 'add' and we dont' have a sourceId yet), do nothing
		if (this.noteSource == null || this.noteSourceId == null)
		{
			setTimeout(() =>
			{
				// we have to wait a second as the table is still loading to prevent a ExpressionChangedAfterItHasBeenCheckedError
				this.loading = false;
			}, 1);
			return;
		}

		this.noteService.findBySource(
			pageNumber, event.rows,
			event.sortField,
			event.sortOrder,
			event.multiSortMeta,
			event.globalFilter,
			event.filters,
			this.noteSource,
			this.noteSourceId).pipe(first()).subscribe(

				apiResponse =>
				{
					console.log('notes are: ' + JSON.stringify(apiResponse));
					this.datasource = apiResponse.data.notes;
					this.notes = apiResponse.data.notes;
					this.recordTotal = apiResponse.page.recordTotal;
				},
				apiResponse =>
				{
					console.log('USER LIST!: ' + JSON.stringify(apiResponse));
					this.alertService.error(apiResponse);
				},
				() =>
				{ this.loading = false; }
			);

		try
		{
			if (this.datasource)
			{
				this.notes = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error)
		{
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Note',
			noteSource: this.noteSource,
			noteSourceId: this.noteSourceId

		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(NoteComponent, dialogConfig);

    // Add class to body
    console.log('Adding class to body');
    this.renderer.addClass(document.body, 'custom-body-class');

    dialogRef.afterClosed().subscribe(() => {
      // Remove the class from body when dialog closes
      console.log('Removing class from body');
      this.renderer.removeClass(document.body, 'custom-body-class');
    });


		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addNoteCB(data);

				// close the dialogBox
				dialogRef.close();
			});
    dialogRef.componentInstance.doUpdate.subscribe(data => { this.updateNoteCB(data); dialogRef.close(); });
    dialogRef.componentInstance.doAddDontClose.subscribe( data => {this.addNoteCB(data); });
    dialogRef.componentInstance.doUpdateDontClose.subscribe( data => {this.updateNoteCB(data); });
	}


	/*********
	* Edit Button
	*
	*/
	onOpenFormEdit(note: any) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			note: note,
			title: 'Edit Note'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(NoteComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);
				this.updateNoteCB(data);
				dialogRef.close();
			});
    dialogRef.componentInstance.doUpdateDontClose.subscribe( data => { this.updateNoteCB(data); });

		// dialogRef.componentInstance.doDelete.subscribe(
		// 	data => {
		// 		console.log('Dialog output:', data);

		// 		// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
		// 		this.deleteProformaIncomeCB(data);

		// 		// close the dialogBox
		// 		dialogRef.close();
		// 	});
	}

	updateNoteCB(note: any) {
		console.log('Updating note: ' + JSON.stringify(note));
		let itemIndex = this.notes.findIndex((item: any) => item.noteId === note.noteId);
		this.notes[itemIndex] = note;

		// no idea what this is but it is required to update the array
		this.notes = [...this.notes];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Note ' + note.noteId + ' Updated', life: 3000 });
	}

	addNoteCB(note: any) {
		console.log('Adding (note: ' + JSON.stringify(note));
		// if we don't have a proformaIncomes array yet...
		if (!this.notes) {
			this.notes = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.notes.unshift(note);

		// no idea what this is but it is required to update the array
		this.notes = [...this.notes];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Note ' + note.noteId + ' Added', life: 3000 });
	}

	sortList(event)
	{
		console.log('formTest', event);
		this.multiSortMeta = [];
		this.multiSortMeta.push({ field: event.value.value, order: 0 });
		this.lazyLoadEvent.multiSortMeta = this.multiSortMeta;
		this.loadLazy(this.lazyLoadEvent);
	}

	updateToNoteList(event)
	{
		console.log('updateNoteList', event);
		this.notes.map((note, i) =>
		{
			if (note.noteId === event.noteId)
			{
				this.notes[i] = event;
			}
		});
	}


	ngOnChanges()
	{
		// This is called when the parent updates. When the parent first initializes, it is in add state, and we have no taskId.  This sets the taskId when add is successful.
		if (this.noteAddForm !== undefined)
		{
			this.noteAddForm.patchValue({ noteSourceId: this.noteSourceId });
		}
	}

	buildAddForm()
	{
		this.noteAddForm = this.formBuilder.group({
			noteId: [],
			noteSourceId: [this.noteSourceId],
			noteSource: [this.noteSource],
			createDate: [],
			lastUpdate: [],
			title: [],
			description: [],
			status: [],
			noteType: [1, Validators.required],
			visibility: [1, Validators.required]
		});
	}

	buildEditForm()
	{
		this.noteEditForm = this.formBuilder.group({
			noteId: [],
			noteSourceId: [this.noteSourceId],
			noteSource: [this.noteSource],
			createDate: [],
			lastUpdate: [],
			title: [],
			description: [],
			status: [],
			noteType: [1, Validators.required],
			visibility: [1, Validators.required]
		});
	}

	patchNote(note)
	{
		this.noteEditForm.patchValue(note);
	}

	reloadPage() {
		window.location.reload();
	}

	displayPaginator()
	{
		if (this.notes && this.notes.length > 25)
		{
			return true;
		}
		else
		{
			return false;
		}
	}

	shortDesc(text: any) {
    if (!text) { return ''; }
		if (text?.length > 50){
			return text?.substring(0, 50) + '...';
		}else{
			return text?.substring(0, 50);
		}
	}
}
